export default __webpack_public_path__ + "static/media/Enforcer's Favor.fbaf66f6.jpg";